import React, { useEffect, useState } from "react";
import { MdOutlineCancel } from "react-icons/md";
import { BsCheck2Circle } from "react-icons/bs";
import styled from "styled-components";
import { useStateContext } from "../contexts/ContextProvider";
import { motion } from "framer-motion";

const DescriptionAlerts = () => {
  const { deletedFromLocalStorage, setAlert, timeRemaining, setTimeRemaining } =
    useStateContext();
  // Function to truncate a string if it exceeds a specified length
  function truncate(string, n) {
    return string?.length > n ? string.substr(0, n - 1) + "..." : string;
  }

  useEffect(() => {
    // Timer for countdown and alert dismissal
    const timer = setTimeout(() => {
      if (timeRemaining > 0) {
        setTimeRemaining(timeRemaining - 1);
      }
      if (timeRemaining === 0) {
        setTimeout(() => {
          setAlert(false);
        }, 400);
      }
    }, 100);

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, [timeRemaining, deletedFromLocalStorage]);

  // Calculate the time remaining with respect to 100 units
  const timeWithRespectTo100 = Math.round((timeRemaining / 10) * 100);

  return (
    <motion.div
    initial={{
      height: "17rem",
    }}
    animate={{
      height: "8rem",
    }}
    transition={{
      type: "spring",
      duration: 1,
    
    }}
  >
    <Component>
      <DetailWrapper>
        <img src={deletedFromLocalStorage[0].image} alt="" srcset="" />
        <DeleteInfo>
          {/* Display truncated description */}
          <div className="deleteinfo">
            {truncate(deletedFromLocalStorage[0].descr, 70)}
          </div>
          <p>
            <BsCheck2Circle /> Item Successfully Deleted
          </p>
        </DeleteInfo>
      </DetailWrapper>

      {/* Progress bar */}
      <Progress
        style={{
          width: `${timeWithRespectTo100}%`,
        }}
      ></Progress>

      <MdOutlineCancel className="cancel" onClick={() => setAlert(false)} />
    </Component>
    </motion.div>
  );
};

export default DescriptionAlerts;

const Component = styled.div`
  height: 20vh;
  width: 40vw;
  display: flex;
  flex-direction: column;
  padding: 14px;
  background-color: red;
  border: 1px solid #ecbbbb;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  backdrop-filter: blur(20px);
  position: relative;
  @media (max-width: 481px) {
    width: 100vw;
    padding: 4px;
  }
  img {
    height: 14vh;
    width: 14vw;
    object-fit: contain;
    padding-right: 10px;
  }
  .cancel {
    position: absolute;
    top: 4px;
    right: 4px;
    font-size: 20px;
    cursor: pointer;
    @media (max-width: 481px) {
      left: 4px;
    }
  }
`;

const DetailWrapper = styled.div`
  display: flex;
  padding-top: 20px;
`;

const DeleteInfo = styled.div`
  height: 20px;
  .deleteinfo {
    font-size: 12px;
    display: flex;
    justify-content: column;
    align-items: flex-start;
  }
  p {
    color: #105910;
    @media (max-width: 481px) {
      font-size: 12px;
    }
  }
`;

const Progress = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  height: 7px;
  background-color: red;

  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  transition: all 0.1s ease-in-out;
`;
